// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/gift.js';

import { paths } from '../generated/gift';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('gift', Original, paths);
